import type { FunctionComponent } from 'react'
import React from 'react'

import classnames from 'classnames'

import { Link } from '../../../Link'
import styles from './CardContainer.module.scss'

export const CardContainer: FunctionComponent<Props> = ({
  primaryLink,
  ariaLabel,
  arrangement = 'default',
  children,
  onClickHandler,
  trackingData,
  id = 'card-container',
}) => {
  const hasLink = primaryLink && ariaLabel ? true : false
  const isCardHorizontal = arrangement === 'horizontal' ? true : false
  const isCardCenter = arrangement === 'center' ? true : false

  return (
    <article
      className={classnames(styles.cardContainer, {
        [styles.cardContainerHorizontal]: isCardHorizontal,
        [styles.cardContainerCenter]: isCardCenter,
        [styles.cardContainerHover]: hasLink,
      })}
      data-testid="card-container"
      onClick={onClickHandler}
      onKeyDown={onClickHandler}
      id={id}
      role="none"
    >
      {hasLink && (
        <Link
          aria-label={ariaLabel}
          className={styles.cardContainerLink}
          href={primaryLink}
          includeIcon={false}
          {...trackingData}
        />
      )}
      {children}
    </article>
  )
}

export type Props = {
  /**
   * URL for destination of card, must be used in conjunction with ariaLabel
   */
  primaryLink?: string
  /**
   * Arrangement of child elements
   */
  arrangement?: 'default' | 'center' | 'horizontal'
  /**
   * aria-label attribute can be used to define a string that labels the interactive element
   */
  ariaLabel?: string
  /**
   * Function to be passed to on click of onClickHandler component.
   */
  onClickHandler?: () => void
  /**
   * Optional Id
   */
  id?: string
  /**
   * Optional data tracking attributes for the link
   */
  trackingData?: { [key: string]: string }
}
